/* eslint no-param-reassign: ["off"] */

import axios from 'axios';

import router from '../router';

const BASE_API_URL = `${process.env.VUE_APP_BASE_URI}/api`;
const IMAGE_DIR = process.env.VUE_APP_IMAGE_DIR;

// https://github.com/axios/axios#creating-an-instance
const instance = axios.create({
  baseURL: BASE_API_URL,
  timeout: false,
  params: {}, // init param object: will be filled later.
});

// REQUEST INTERCEPTOR
// https://github.com/axios/axios#interceptors
instance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('mh-token');
    if (token) {
      config.headers.common.Authorization = `Bearer ${token}`;
      // config.headers.common['Access-Control-Allow-Origin'] = '*';
    }
    return config;
  },
  error => Promise.reject(error),
  // do something with request error
);

// RESPONSE INTERCEPTOR
// https://blog.sqreen.io/authentication-best-practices-vue/
instance.interceptors.response.use(response => response, (error) => {
  if (error.response.status === 401) {
    router.push('/logout');
  }
  return error;
});

export default {
  baseURL() {
    return BASE_API_URL;
  },
  imageDir() {
    return IMAGE_DIR;
  },
  getData(action) {
    let url = `${BASE_API_URL}`;
    url += action;
    return instance.get(url);
  },
  postData(action, data) {
    let url = `${BASE_API_URL}`;
    url += action;
    return instance.post(url, data);
  },
  putData(action, data) {
    let url = `${BASE_API_URL}`;
    url += action;
    return instance.put(url, data);
  },
  deleteData(action) {
    let url = `${BASE_API_URL}`;
    url += action;
    return instance.delete(url);
  },
  // AUTHENTICATION
  login(email, password) {
    const url = `${BASE_API_URL}/auth/login`;
    return instance({
      method: 'post',
      url,
      auth: {
        username: email,
        password,
      },
    });
  },
};
